<!-- 
  /** 
  * @author Mau de Pallares 
  * @company Erillam Healthcare 
  * @version 2.0 
  */ -->
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      hide-default-footer
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="openModal(item)">
              <v-icon color="gray" v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </v-btn>
          </template>
          <span>Información de estudio</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.interpretationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.interpretationDate) || '- - -'}}
      </template>
      <template v-slot:[`item.sendServiceDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.sendServiceDate) }}
      </template>
      <template v-slot:[`item.nameBirads`]="{ item }">
        <v-chip :color="$utilFront.getColorBirads(item.nameBirads)">
          {{ item.nameBirads }}
        </v-chip>
      </template>
      <template v-slot:[`item.idInterpretation`]="{ item }">
          {{ item.idInterpretation || '- - -'}}
      </template>
      <template v-slot:[`item.fullNameInterpreter`]="{ item }">
          {{ item.fullNameInterpreter || '- - -'}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";

export default {
  name: "PsychologyPendingTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    updateStatus: Function,
    itemsPerPage: Number,
  },
  components: {
    MenuCrud,
    CancelationModal,
  },
  data() {
    return {
      idPatient: null,
      appointmentDialog: false,
      dataModal: {},
      dialogCancelation: false,
      headers: [
        {
          text: "Id interpretación",
          value: "idInterpretation",
          sortable: false,
          align: "center",
        },
        {
          text: "Id estudio",
          value: "idStudy",
          sortable: false,
          align: "center",
        },
        {
          text: "Nombre del paciente",
          value: "fullNamePatient",
          align: "center",
          sortable: false,
        },
        {
          text: "Modalidad",
          value: "fullNameModality",
          align: "center",
          sortable: false,
        },
        {
          text: "Perfil de estudio",
          value: "fullNameStudyProfile",
          align: "center",
          sortable: false,
        },
        {
          text: "BI-RADS",
          value: "nameBirads",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha de interpretación",
          value: "interpretationDate",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha de envío",
          value: "sendServiceDate",
          align: "center",
          sortable: false,
        },
        {
          text: "Intérprete",
          value: "fullNameInterpreter",
          align: "center",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  methods: {
    openModal(item) {
      this.viewSendingDetails = true;
      this.$emit("openModal", this.viewSendingDetails, {idSendInterpretation: item.idSendInterpretation});
    }
  },
};
</script>
